import { Field, formValueSelector, reduxForm } from 'redux-form';
import { getMasterData, getMasterDiagnosisByName, getPatientDiagnosisDetails, saveProblemData } from '../../actions/PatientActions';
import React, { Component } from 'react';
import {
  renderAutoCompleteSingleSelect,
  renderDateField,
} from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
  const error = {};
  if (!values.icdid) {
    error.icdid = 'Please select a diagnosis';
  }
  if (!values.diagnosisDate) {
    error.diagnosisDate = 'Please enter diagnosis date';
  }
  if (!values.resolveDate) {
    error.resolveDate = 'Please enter resolved date';
  }
  return error;
};
class ProblemModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      isSaveAddBtn: false,
      masterICD: props.patientMasterData.masterICD ? props.patientMasterData.masterICD : [],
      PatientID: props.patientid,
    };
    this.onDateChange = this.onDateChange.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillMount() {
    if (this.props.diagnosisId) {
      this.props.getPatientDiagnosisDetails(this.props.diagnosisId);
    }
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format('YYYY-MM-DD'));
    this.setState({ [input.name]: value });
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.patientMasterData && this.props.patientMasterData !== nextProps.patientMasterData) {
      let masterData = nextProps.patientMasterData;

      this.setState({
        masterICD: masterData.masterICD,
      });
    }

    // if (this.state.isSaveAddBtn) { // Enable Add new data
    //   if ((nextProps.history_created && this.props.history_created !== nextProps.history_created)) {
    //     this.props.dispatch(reset('ProblemModal'));
    //     this.props.dispatch(change('ProblemModal', 'dob', ''));
    //     this.props.dispatch(change('ProblemModal', 'dateOfDeath', ''));
    //   }
    // } else {
    //   if ((nextProps.history_created && this.props.history_created !== nextProps.history_created) && !this.state.isSaveAddBtn) {
    //     this.setState({ open: false });
    //     this.props.closeDialog();
    //   }
    // }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  onSubmitHandler(formProps) {
    if (formProps.isActive === true || formProps.isActive === undefined) {
      formProps.isActive = true;
      formProps.resolveDate = null;
    }
    formProps.patientID = this.state.PatientID;
    this.props.saveProblemData(formProps);
    this.handleClose();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <CommonButton primary={true} className="loader_btn" disabled = {true } label= "Saving"/> :
      <div style={{ display: 'inline-block' }}>
        <CommonButton type="submit" primary={true} label= "Save" onTouchTap={handleSubmit(this.onSubmitHandler.bind(this))}/>
      </div>;
    const actions = [
      <CommonButton className="mr-15 grey_btn" label = 'Cancel' onTouchTap={this.handleClose}/>,
      submitButton,
    ];
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={this.props.diagnoseObj ? 'Edit Diagnosis' : 'Add Diagnosis'}
            modal={false}
            open={this.state.open}
            actions={actions}
            autoScrollBodyContent={true}
          >
            {this.renderLoading()}
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-12 require mt-35">
                      <Field
                        name="icdid"
                        label="Diagnosis"
                        options={this.state.masterICD}
                        handleNewRequest={this.handleNewRequest}
                        component={renderAutoCompleteSingleSelect}
                        openOnFocus={true}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-sm-6 mt-35">
                      <Field
                        name="isActive"
                        label="Problem Status"
                        handleNewRequest={this.handleNewRequest}
                        options={[{ id: true, value: 'Active' }, { id: false, value: 'Inactive' }]}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-6 require">
                      <Field
                        name="diagnosisDate"
                        placeholder="Date of diagnosis"
                        component={renderDateField}
                        openToYearSelection = {true}
                        maxDate={new Date()}
                        locale="en-US"
                        selected={this.props.diagnosisDate}
                        onDateChange={this.onDateChange}
                      />
                    </div>
                    {(this.props.isActive !== undefined && !this.props.isActive) ?
                      <div className="col-sm-6 require">
                        <Field
                          name="resolveDate"
                          placeholder="Date Resolved"
                          component={renderDateField}
                          openToYearSelection = {true}
                          maxDate={new Date()}
                          locale="en-US"
                          selected={this.props.resolveDate}
                          onDateChange={this.onDateChange}
                        />
                      </div> :
                      ''
                    }
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

const selector = formValueSelector('ProblemModal');

function mapStateToProps(state, ownProps) {

  let initialValueData = null;
  if (ownProps.diagnosisId && state.patient.patientDiagnosisDetail) {
    initialValueData = state.patient.patientDiagnosisDetail.data || null;
  }
  return {
    loading: state.patient.loading,
    searched_ICDs: state.patient.searched_ICDs,
    history_created: state.patient.history_created,
    medical_history: state.patient.medical_history,
    isActive: selector(state, 'isActive'),
    resolveDate: selector(state, 'resolveDate'),
    diagnosisDate: selector(state, 'diagnosisDate'),
    initialValues: initialValueData,
  };
}
ProblemModal = reduxForm({
  form: 'ProblemModal',
  validate,
  enableReinitialize: true,
})(ProblemModal);
export default connect(mapStateToProps, { getMasterData, getMasterDiagnosisByName, getPatientDiagnosisDetails, saveProblemData })(ProblemModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/diagnosis/problem-modal.js